module.exports = __webpack_public_path__ + "img/Edit.b693756e.svg";